module.exports = "<div class=\"_app\">\n  <v-app id=\"app-container\">\n\n    <transition name=\"fade\">\n      <router-view></router-view>\n    </transition>\n\n    <cm-global-notification></cm-global-notification>\n\n  </v-app>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/app/app.vue
// module id = 412
// module chunks = 0